import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

// Tell MUI's DataGrid types that our overlays accept a `message` (and the
// loading overlay a `size`) prop. Without this, TypeScript rejects passing
// these through `slotProps.loadingOverlay` / `slotProps.noRowsOverlay`
// because it doesn't know these props exist on the slot.
declare module "@mui/x-data-grid" {
  interface LoadingOverlayPropsOverrides {
    message?: string;
    size?: number;
  }
  interface NoRowsOverlayPropsOverrides {
    message?: string;
  }
}

interface CustomLoadingOverlayProps {
  message?: string;
  size?: number;
}

/**
 * Reusable loading overlay for MUI DataGrid.
 * Pass via: slots={{ loadingOverlay: CustomLoadingOverlay }}
 * Customize per-grid via: slotProps={{ loadingOverlay: { message: "Loading contacts..." } }}
 */
export function CustomLoadingOverlay({
  message = "Loading...",
  size = 32,
}: CustomLoadingOverlayProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        gap: 1.5,
        py: 4,
      }}
    >
      <CircularProgress size={size} thickness={4} />
      <Box sx={{ fontSize: 14, color: "text.secondary" }}>{message}</Box>
    </Box>
  );
}

interface CustomNoRowsOverlayProps {
  message?: string;
}

/**
 * Reusable "no rows" overlay for MUI DataGrid.
 * Pass via: slots={{ noRowsOverlay: CustomNoRowsOverlay }}
 * Customize per-grid via: slotProps={{ noRowsOverlay: { message: "No contacts found" } }}
 */
export function CustomNoRowsOverlay({
  message = "No rows",
}: CustomNoRowsOverlayProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        py: 4,
      }}
    >
      <Box sx={{ fontSize: 14, color: "text.secondary" }}>{message}</Box>
    </Box>
  );
}